<template>
  <div id="app_content" class="public">
    <div class="container">
      <div class="row">
        <div class="col-md-7" v-if="mounted">
          <breadcrumb :elemento="false" :key="breadKey" v-if="$store.state.breadcrumb !== null" />
        </div>
        <div class="col-md-5 other-macro" v-if="mounted && otherMacro">
          <a :href="url('/catalog/' + otherMacro.link)"
            >{{ trans.get('public.macro.discover') }} {{ ($store.state.current_lang === 'it')? otherMacro.text_it : otherMacro.text_eng }}
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25.45"
                height="11.322"
                viewBox="0 0 25.45 11.322"
              >
                <g
                  id="Raggruppa_269"
                  data-name="Raggruppa 269"
                  transform="translate(-626.257 -107.125)"
                >
                  <path
                    id="Tracciato_94"
                    data-name="Tracciato 94"
                    d="M-293.192,276.7l4.346-3.022a2.682,2.682,0,0,0-.014-4.5l-4.331-2.975"
                    transform="translate(938.836 -158.66)"
                    fill="none"
                    stroke="#abc932"
                    stroke-miterlimit="10"
                    stroke-width="1"
                  />
                  <line
                    id="Linea_13"
                    data-name="Linea 13"
                    x1="24.858"
                    transform="translate(626.257 112.81)"
                    fill="none"
                    stroke="#abc932"
                    stroke-miterlimit="10"
                    stroke-width="1"
                  />
                </g>
              </svg>
            </span>
          </a>
        </div>
      </div>

      <div class="row" v-if="cod_macro === 'CIN' || cod_macro === 'NAS'">
        <!--        navbar famiglie     -->
        <div class="col-md-12 family-list row" v-if="mounted">
          <div
            class="fam-icon"
            v-for="(fam, index) in families"
            v-if="fam.codice !== 'CUS' && fam.codice !== 'POL'"
            :key="index"
            :style="
              windowWidth > 576
                ? 'width:calc(70% / ' + families.length + ');'
                : 'width:calc(70% / ' + half + ' );'
            "
          >
            <families

              :macro="cod_macro"
              :codice="fam.codice"
              :active="active === fam.codice"
              @active="setActive"
              :descrizione="fam.descrizione"
            />
          </div>
        </div>
        <div class="col-md-12">
          <hr />
        </div>
      </div>

      <div class="row">
        <!--        articoli cat - color-->
        <catcolor :key="catColorKey" v-if="catColor" />
        <div class="col-md-12" v-else>
          <p>{{ trans.get('public.macro.not-found') }}</p>
        </div>
      </div>
    </div>
    <div class="inner-section newsletter">
      <div class="section-container">
        <div class="my-content">
          <form_newsletter_new />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from "./components/breadcrumb";
import families from "./components/families";
import catcolor from "./components/cat-color";
import filterProds from "./components/filter";
import form_newsletter_new from "./../form-newsletter-new"

export default {
  name: "index",
  components: { breadcrumb, families, catcolor, filterProds, form_newsletter_new },
  data() {
    return {
      mounted: false,
      cod_macro: null,
      families: null,
      active: null,
      catColor: false,
      breadKey: 0,
      otherMacro: null,
      catColorKey: 0,
      windowWidth: window.innerWidth,
      txt: "",
      half: null,
    };
  },
  watch: {
    windowWidth(newWidth, oldWidth) {
      this.txt = `it changed to ${newWidth} from ${oldWidth}`;
     // console.log(this.txt);
      this.getHalf();
    },
    "$store.state.catalog.catcolor": function () {
      this.catColorKey++;
    },
  },

  mounted() {
    this.ifFam();
    this.spliceUrlMacro();
    this.calcOtherMacro();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },

  methods: {
    getHalf: function () {
      this.half = this.families.length / 1.5;
    },
    onResize() {
      var vue = this;
      vue.windowWidth = window.innerWidth;
     // console.log(vue.windowWidth);
    //  console.log("length" + vue.families.length);
      this.getHalf();
     // console.log(vue.half);
    },

    ifFam: function () {
      let pathname = window.location.pathname.split("/");
      if (pathname.length === 5) {
        let fam = pathname[4];
        this.active = fam;
        this.cod_macro = pathname[2];
        //console.log(fam)
      } else {
        this.cod_macro = pathname[pathname.length - 1];
      }
    },
    calcOtherMacro: function () {
      switch (this.cod_macro) {
        case "CIN":
          this.otherMacro = {
            text_it: "Accessori per Nastri Trasportatori",
            text_eng: "Conveyor's components",
            link: "NAS",
          };
          break;
        case "NAS":
          this.otherMacro = this.otherMacro = {
            text_it: "Cinghie Termosaldanti",
            text_eng: "Thermoweldable belts",
            link: "CIN",
          };
      }
    },
    getCatColor: function () {
      axios({
        method: "get",
        url: window.location.origin + "/catalog/api/catcolor",
        params: {
          code: this.active,
          macro: this.cod_macro
        },
      }).then((res) => {
         console.log('getCatColor', res.data)

        this.$store.commit("setCatColors", res.data);
        this.$store.commit("setCatColorsTemp", res.data);
        this.breadKey++;
        if (res.data.length > 0) {
          this.catColor = true;
        }
      }).catch(err => {
        console.log(err.response.data.message)
      });
    },
    setActive: function (index) {
      this.active = index;
      this.catColor = false;
      this.getCatColor();
    },
    spliceUrlMacro: function () {
      // let pathname = window.location.pathname.split("/");
      // this.cod_macro = pathname[pathname.length - 1];
      this.getFamilies();
    },
    getFamilies: function () {
      axios({
        method: "get",
        url: window.location.origin + '/data/get-family',
        params: {
          type: 'filter-f',
          // code: this.cod_macro,
          cod: this.cod_macro,
          public: true,
        },
      })
        .then((res) => {
          this.families = res.data.family;
          this.getHalf();
          if (this.active === null) {
            this.active = this.families[0].codice;
          }
          this.mounted = true;
          this.getCatColor();
        })
        .catch((err) => {
          console.log(err.response.data.message);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$greenprod: #abc932;
#app_content.public {
  p,
  span,
  div {
    color: #fff;
  }

  background-color: var(--black-2);

  .inner-section {
    width: 100vw;
    &.newsletter {
      background-color: #0e0e0e;
      margin-top: auto;
    }
    .my-content > div {
      padding: 0 20px;
    }
  }

  .container {
    max-width: 100%;
    margin: 0;
    padding: 200px 0;
    @media (max-width: 1200px) {
      padding: 70px 0;
    }

    @media (min-width: 1200px) {
      max-width: calc(100% - var(--public-menu-width));
      margin: 0 0 0 var(--public-menu-width);
      padding: 100px;
    }

    .other-macro {
      color: $greenprod;
      display: flex;
      justify-content: flex-end;
    }
    hr {
      margin-top: 50px;
      background-color: #707070;
      width: 100%;
      height: 1px;
    }

    .family-list {
      height: 180px;
      // display: flex;
      margin: 0;
      margin-top: 20px;
      padding: 0;
      @media (max-width: 576px) {
        flex-wrap: nowrap;
        overflow-x: auto;
      }
      .fam-icon {
        margin: 0 15px;
      }
      .fam-icon:first-child{
        margin-left: 0;
      }
    }
  }
}
</style>
